import React from "react";
import FadeInSection from "../../components/FadeInSection";
import ImgAboutUs from "../../../images/pngs/about-us.png";
import ImgOrfordBadge from "../../../images/svgs/club-badge.svg";

const AboutUs = () => {
    return(
        <FadeInSection>
            <section className="row gap-2 mb-3" id="about-us">
                <div className="container">
                <div className="col-12-xs col-6-md col-8-lg">
                    <div className="card">
                        <h2 className="mb-1">About Us</h2>
                        <p>We are a passionate organisation that helps to <strong>Support Grassroots Football</strong> and we are based in Warrington, Cheshire. We provide Sports Club management software to help you unlock the potential of your club through management of everything from Players to Subs.</p>
                        <p>Our new platform gives you first class insights into your club from both a financial perspective and from a welfare and player perspective.  Our platform includes a Shop, Subs Mangement, Coaches Corner and much more.</p>
                        <p>We have partnered with Stripe.com to provide you with integrated payments for any scenario.</p>
                    </div>
                </div>
                <div className="col-12-xs col-6-md col-4-lg">
                    <div className="card">
                        <img src={ImgAboutUs} alt="About 360 Grassroots"/>
                        <img src={ImgOrfordBadge} alt="About Us" className="about-us-img"/>
                    </div>
                </div>
                </div>
            </section>
        </FadeInSection>
    )
}

export default AboutUs;